/**
 * Title emphasis for the public site.
 *
 * Admins write a headline with *asterisks* around the words they want
 * accented (gold italic), e.g. "Spaces built for *learning*". This is far
 * easier than typing raw <em> HTML. We convert `*…*` to `<em>…</em>` at
 * render time, escaping everything else so the string is safe to pass to
 * dangerouslySetInnerHTML.
 *
 *   <h1 dangerouslySetInnerHTML={{ __html: emphasize(headline) }} />
 */
export function emphasize(input) {
  if (!input || typeof input !== 'string') return '';
  // Escape HTML first so admin text can never inject markup.
  const escaped = input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  // Then turn *word* pairs into <em>word</em>. Non-greedy, must have content.
  return escaped.replace(/\*([^*]+)\*/g, '<em>$1</em>');
}

/**
 * Convert legacy <em>…</em> HTML into the *asterisk* form. Used to normalise
 * the old hard-coded fallback titles so everything renders through emphasize().
 */
export function emToStars(input) {
  if (!input || typeof input !== 'string') return '';
  return input.replace(/<\/?em>/gi, '*');
}
